








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { language, CustomException } from '@tencent/ppd-base-libs';
import { getCurrentLangData } from './business';
import LanuchWeapp from '@/components/LaunchWeapp.vue';// 此处是唯一依赖外部组件的地方，因为打开微信小程序组件，已被多个仓库复用，完全内部依赖可以查看，疫情模块的https://git.code.oa.com/ppd-hkwallet/hk-disease
import Banner from './banner.vue';
import exposure from './exposure';
import { biHT } from '@/business/bi';

const nativeWordsMap = {
  soldout: {
    'zh-cn': '售罄',
    'zh-hk': '售罄',
    en: 'Sold Out',
  },
  around: {
    'zh-cn': '约',
    'zh-hk': '約',
    en: 'Around',
  },
};
@Component({
  components: {
    LanuchWeapp,
    Banner,
  },
  directives: {
    exposure,
  },
})
export default class FitThirdProduct extends Vue {
  @Prop({ default: '' }) public moduleName!: string;

  public lang = language.getLanguage();
  public data: any = {};
  public products: any = [];
  public banners: any = [];
  public curGroupIndex = 0; // 换一批索引
  public perCount = 6;  // 每组几个（默认6个）
  public wordSoldout = nativeWordsMap.soldout[this.lang];
  public wordAround = nativeWordsMap.around[this.lang];
  // 获取sku配置数据
  public async created() {
    this.data = await getCurrentLangData(this.moduleName);
    if (!this.data) return;

    this.banners = this.data.banners ? JSON.parse(JSON.stringify(this.data.banners)) : [];

    // 配置随机择使用随机顺序
    if (this.data.products) {
      // 隐藏售罄商品
      this.data.products = this.data.products.filter(item => item.soldOut !== 'true');
      if (this.data.randomSort === '1') {
        this.data.products.sort(() => Math.random() - 0.5);
      }
    }
    if ('1' === this.data.isShow3Item) {
      this.perCount = 3;
    }
    this.setProducts(true);
  }

  // 跳转
  public goThirdProduct(id, index, item) {
    biHT('wallet.goods.scenes.product_click', { fuid: id, fposition: index, from: this.moduleName });

    if (item.mpcode) return;// 跳小程序的不跳链接
    setTimeout(() => {
      window.location.href = item.link;
    }, 300);
  }
  // 更多
  public goSkuMarket() {
    biHT('wallet.goods.channel.entrance_click');
    const tabid = this.data.entranceTabId;
    let tabStr = '';
    if (tabid)tabStr = `&tabid=${tabid}`;
    setTimeout(() => {
      window.location.href = `https://prom.wechatpay.com.hk/sku/index.shtml?from=${this.moduleName}${tabStr}`;
    }, 300);
  }
  // 获取带有前置词，如‘约22’中的数字
  public getMoneyNum(money) {
    if (!money) return '';
    const m = money.replace(/[^0-9.]/g, '');
    const arr = m.split('.');
    return arr[1] == '00' ? arr[0] : m;
  }
  // 获取前置词，如‘约22’中的‘约’字
  public getPreWord(money) {
    if (!money) return '';
    return money.replace(/[0-9.,]/g, '');
  }
  // 切换产品
  public setProducts(isinit: Boolean) {
    const len =  this.data.products.length;
    const groupNum = Math.floor(len / this.perCount);// 取整组的个数
    const sur = len % this.perCount;// 取模
    if (this.curGroupIndex === groupNum && sur > 0) {
      this.products = this.data.products.slice(this.perCount * groupNum);
      if (groupNum === 0) return;
      const temp = this.data.products.slice(0, this.perCount - sur);
      this.products = this.products.concat(temp);
      this.curGroupIndex = 0;
    } else {
      this.products = this.data.products.slice(
        this.perCount * this.curGroupIndex,
        this.perCount * this.curGroupIndex + this.perCount,
      );
      this.curGroupIndex += 1;
      if (this.curGroupIndex === groupNum && sur === 0) this.curGroupIndex = 0;
    }
    // 初始化无点击流
    if (!isinit) {
      biHT('wallet.goods.scenes.button_click', { from: this.moduleName });
    }
  }
}
